
import {FC, Tab, Tabs} from 'external/react'
import useParent from 'context/parent-context/hook'
import PackageTab from './PackageTab'

const UserPackages:FC = () => {

        const {state:  {userPackageDetails: {items: packages}}, params: {role}} = useParent()

        return (
                <Tabs defaultActiveKey={0} className='mt-3'>
                        {packages.map((p, i) => (
                                <Tab eventKey={i} key={i} title={`Plan ${p.offerName} (${p.plan_alias})`}>
                                        <PackageTab role={role} packageItem={p}/>
                                </Tab>
                        ))}
                </Tabs>
        )
}

export {UserPackages as default}